import * as ambassadorWixGatewaysBillingV1TaxCalculationGateway from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.http.js';
import * as ambassadorWixGatewaysBillingV1TaxCalculationGatewayTypes from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.types.js';
import * as ambassadorWixGatewaysBillingV1TaxCalculationGatewayUniversalTypes from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function calculateTax(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayUniversalTypes.CalculateTaxRequest,
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayTypes.CalculateTaxRequest,
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayUniversalTypes.CalculateTaxResponse,
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayTypes.CalculateTaxResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixGatewaysBillingV1TaxCalculationGateway.calculateTax(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/calculate-tax',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listTaxCalculators(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayUniversalTypes.ListTaxCalculatorsRequest,
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayTypes.ListTaxCalculatorsRequest,
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayUniversalTypes.ListTaxCalculatorsResponse,
  ambassadorWixGatewaysBillingV1TaxCalculationGatewayTypes.ListTaxCalculatorsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixGatewaysBillingV1TaxCalculationGateway.listTaxCalculators(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/list-tax-calculators',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TaxCalculationGateway as TaxCalculationGatewayOriginal,
  CalculateTaxRequest as CalculateTaxRequestOriginal,
  Address as AddressOriginal,
  LineItem as LineItemOriginal,
  AddressIndex as AddressIndexOriginal,
  AddressIndexAddressIndexOptionsOneOf as AddressIndexAddressIndexOptionsOneOfOriginal,
  MultipleAddresses as MultipleAddressesOriginal,
  ExemptCalculationDetails as ExemptCalculationDetailsOriginal,
  ExemptCalculationDetailsExemptByOptionsOneOf as ExemptCalculationDetailsExemptByOptionsOneOfOriginal,
  ExemptBy as ExemptByOriginal,
  ExemptByWithLiterals as ExemptByWithLiteralsOriginal,
  CalculateTaxResponse as CalculateTaxResponseOriginal,
  TaxSummary as TaxSummaryOriginal,
  AggregatedTaxBreakdown as AggregatedTaxBreakdownOriginal,
  JurisdictionType as JurisdictionTypeOriginal,
  JurisdictionTypeWithLiterals as JurisdictionTypeWithLiteralsOriginal,
  LineItemTaxDetails as LineItemTaxDetailsOriginal,
  TaxBreakdown as TaxBreakdownOriginal,
  LineItemTaxSummary as LineItemTaxSummaryOriginal,
  ApplicationError as ApplicationErrorOriginal,
  ListTaxCalculatorsRequest as ListTaxCalculatorsRequestOriginal,
  ListTaxCalculatorsResponse as ListTaxCalculatorsResponseOriginal,
  TaxCalculatorDetails as TaxCalculatorDetailsOriginal,
  AggregateTaxBreakdownsRequest as AggregateTaxBreakdownsRequestOriginal,
  AggregateTaxBreakdownsResponse as AggregateTaxBreakdownsResponseOriginal,
  CalculateTaxApplicationErrors as CalculateTaxApplicationErrorsOriginal,
} from './gateways-billing-v1-tax-calculation-gateway-tax-calculation.types.js';
